import { makeStyles } from "@material-ui/core/styles";

export function useServiceDeleteStyles() {
  const useStyles = makeStyles((theme) => ({
    button: {
      color: "#004B97",
      fontSize: "0.95rem",
      padding: "0.5rem 1rem",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    cardHeader: {
      color: "#FFF",
      backgroundColor: "#004B97",
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      marginLeft: theme.spacing(1),
      minWidth: 600,
    },
    cardActions: {
      justifyContent: "flex-end",
      borderTop: "1px solid #F0F0F0",
    },
    textWarning: {
      fontSize: '1rem',
      fontWeight: 400,
    },
    menuItem: {
      gap: 10,
      display: 'flex',
      fontWeight: 500,
      color: '#000',
      '&:hover': {
          textDecoration: 'none',
      },
    },
    duplicateButton: {
      color: '#FFF',
      padding: '0.5rem 1rem',
      fontSize: '0.95rem',
      backgroundColor: '#004B97',
      '&:hover': {
          backgroundColor: '#003366',
      },
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
